import { render, staticRenderFns } from "./EfsMdDiseaseForm.vue?vue&type=template&id=1490d9c4&"
import script from "./EfsMdDiseaseForm.vue?vue&type=script&lang=js&"
export * from "./EfsMdDiseaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports